export default {
  getCashRegisterOperations(state) {
    return state.cashRegisterOperations;
  }
}
